import React from "react";
import styled, { css } from "styled-components";
import space from "../../../utils/space";
var StyledWidthOrg = styled.div.withConfig({
  componentId: "sc-4vye61-0"
})(function (_ref) {
  var $widthSpace = _ref.$widthSpace;
  return css(["width:100%;max-width:", ";"], space($widthSpace));
});
function WidthOrg(_ref2) {
  var widthSpace = _ref2.widthSpace,
    children = _ref2.children;
  return /*#__PURE__*/React.createElement(StyledWidthOrg, {
    $widthSpace: widthSpace
  }, children);
}
export default WidthOrg;